export const fixedTelephoneAry = (save: string | number): string[] => {
  if (save) {
    const ary = save.toString().split('|')
    return ary
  } else {
    return ['', '', '']
  }
}
